import FormatterWorkspace from "../components/formatter/FormatterWorkspace";
import CallToActionApiKey from "../components/formatter/CallToActionApiKey";
import { Button } from "../components/ui/button";
import { toast } from "sonner";
import { Heading } from "@/components/ui/heading";
import { Link } from "react-router-dom";
import { DEFAULT_API_URL } from "../lib/const";
import { Code2, Globe, ShoppingBag, UserPlus } from "lucide-react";

export default function FormatterPage() {
	const apiEndpoint = `${(import.meta.env.VITE_API_URL || DEFAULT_API_URL).replace(/\/+$/, "")}/v1/format`;
	const curlSnippet = `curl -X POST "${apiEndpoint}" \\
  -H "Content-Type: application/json" \\
  -H "x-api-key: YOUR_API_KEY" \\
  --data '{"text":"Your raw text here","mode":"web","output":"html"}'`;

	async function copyApiSnippet() {
		await navigator.clipboard.writeText(curlSnippet);
		toast.success("API snippet copied");
	}

	return (
		<div className="mb-8">
			<FormatterWorkspace />

			<section className="mx-auto max-w-6xl px-6">
				<div className="rounded-2xl border border-slate-200 bg-white p-6 sm:p-8">
					<Heading>Format messy text into clean, structured output</Heading>
					<div className="mt-3 flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
						<div className="max-w-3xl text-sm leading-7 text-slate-700 sm:text-base">
							<p className="max-w-3xl text-sm leading-7 text-slate-700 sm:text-base">
								Turn unstructured product and marketing text into clean, publish-ready content in seconds.
							</p>
							<p className="mt-3">
								Text Formatter helps you quickly clean spacing, detect lists structure, and convert
								raw content into readable text or HTML. Paste text, choose your mode, adjust options,
								and copy production-ready output in seconds.
							</p>
							<Heading as="h2" className="mt-4">
								Completely FREE
							</Heading>
							<ul className="mt-3 list-disc pl-5 space-y-1">
								<li>
									You can use Text Formatter completely for free on web. Explore our{" "}
									<Link to="/examples" className="underline-link">examples</Link>.
								</li>
								<li>
									If you need an API - get a free API key with a generous limit of 50 000 words after{" "}
									<Link to="/register" className="underline-link">registration</Link>.
								</li>
							</ul>
						</div>
						<ul className="flex flex-wrap gap-2 text-xs font-semibold uppercase tracking-[0.08em] text-slate-700 lg:max-w-sm lg:justify-end">
							<li className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-slate-50 px-3 py-1.5">
								<Globe className="h-3.5 w-3.5" />
								Free on web
							</li>
							<li className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-slate-50 px-3 py-1.5">
								<UserPlus className="h-3.5 w-3.5" />
								Free registration
							</li>
							<li className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-slate-50 px-3 py-1.5">
								<ShoppingBag className="h-3.5 w-3.5" />
								Built for e-commerce content
							</li>
							<li className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-slate-50 px-3 py-1.5">
								<Code2 className="h-3.5 w-3.5" />
								API available
							</li>
						</ul>
					</div>
					<div className="mt-6 rounded-xl border border-slate-200 bg-slate-50 p-4">
						<div className="mb-2 flex items-center justify-between gap-3">
							<p className="text-xs font-semibold uppercase tracking-[0.14em] text-slate-600">
								Simple API call
							</p>
							<Button size="sm" variant="secondary" onClick={copyApiSnippet}>
								Copy
							</Button>
						</div>
						<pre className="overflow-x-auto whitespace-pre text-xs leading-5 text-slate-800">
							{curlSnippet}
						</pre>
					</div>

					<CallToActionApiKey className="mt-6" />
				</div>
			</section>
		</div>
	);
}
